import { render, staticRenderFns } from "./submissions.vue?vue&type=template&id=1cf7f9bc&scoped=true"
import script from "./submissions.vue?vue&type=script&lang=js"
export * from "./submissions.vue?vue&type=script&lang=js"
import style0 from "./submissions.vue?vue&type=style&index=0&id=1cf7f9bc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cf7f9bc",
  null
  
)

export default component.exports